import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useReactRouter from 'use-react-router';
import { fade, makeStyles, withStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Dialog, Chip, Divider, Snackbar, Typography, IconButton, MenuItem, TextField, ListItemIcon, ListItemText, Button, ClickAwayListener, Paper, MenuList, Popover, Stepper, Step, StepLabel, StepConnector } from '@material-ui/core';
import SyncIcon from '@material-ui/icons/Sync';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { green } from '@material-ui/core/colors';
import Logo from '../../Assets/Images/newlogo.png';
import RSLogo from '../../Assets/Images/rslogo.png';
import * as actions from '../../Store/Actions';
import axios from '../../Helpers/Axiosbase';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Alert, AlertTitle } from '@material-ui/lab';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import PublishIcon from '@material-ui/icons/Publish';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from 'material-table';
import WarningIcon from '@material-ui/icons/Warning';
import https from 'https';
import { authProvider } from '../../authProvider';



const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#784af4',
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
});

function getBulkCopySteps() {
  return ['Review Selected Configuration', 'Select Target Environment'];
}

function getBulkPublishSteps() {
  return ['Review Selected Configuration', 'Confirm Publish Configuration'];
}

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
    margin: theme.spacing(1),
  },
  search: {
    width: '100% !important',
    marginLeft: '0 !important',
    float: 'right',
    textAlign: 'right',
    fontWeight: 'bold',

    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(60),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    //Menu
    paper: {
      marginRight: theme.spacing(2),
    },
    loader: {
      position: 'absolute',
      left: '40%',
      top: '250px',
    }
  },
  listitemicon: {
    minWidth: '35px',
    color: 'black'
  },
  listitem: {
    paddingLeft: '8px',
    paddingLeft: '8px',
    fontSize: '0.900rem'
  },
  //Action Menu
  loader: {
    position: 'absolute',
    left: '40%',
  },
  typography: {
    padding: theme.spacing(2),
  },

  //Stepper
  div: {
    marginRight: '15px',
    float: 'right',
  },

  button: {
    marginRight: theme.spacing(1),
  },

}));

//Dialog

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

//End Dialog

export default function Header() {
  const classes = useStyles();
  const { history } = useReactRouter();
  const [open, setOpen] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [openSyncAlert, setOpenSyncAlert] = React.useState(false);
  const [openSyncProcessAlert, setOpenSyncProcessAlert] = React.useState(false);
  const prevOpen = React.useRef(open);
  const anchorRef = React.useRef(null);

  const [steps, setSteps] = React.useState([]);

  const [selectedMenuItem, setselectedMenuItem] = React.useState("");

  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const [state, setState] = React.useState({
    environments: [],
    showLoader: false,
  });

  const reduxAuth = useSelector((state) => state.auth)
  const appcomponent = useSelector((state) => state.appcomponent)
  const account = authProvider.getAccountInfo();
  const avtar = `https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=` + account.account.name;

  //Dialog Table
  const [columns] = React.useState([
    { title: 'Domain', field: 'domain' },
    { title: 'Relationship', field: 'relationship' },
    { title: 'EntityType', field: 'entityType' },
    { title: 'Role', field: 'role' },
    {
      title: 'Status', field: 'isPublished', render: rowData => {
        if (rowData.isPublished === false) {
          return <Chip size="small" label="UnPublished" color="secondary" />
        }
        else {
          return <Chip size="small" label="Published" color="primary" />
        }
      }
    },
  ]);
  //End Dialog Table

  //Dispatch
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  //Menu  
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }
  //End Menu

  //Action Menu
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleActionClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleActionClose = () => {
    setAnchorEl(null);
  };

  const openAcion = Boolean(anchorEl);
  const id = openAcion ? 'simple-popover' : undefined;
  //End Action Menu

  //Dialog
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleDialogClickOpen = () => {
    setOpenDialog(true);
  };
  const handleDialogClose = () => {
    setActiveStep(0);
    setOpenDialog(false);
  };

  //End Dialog

  //Stepper
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = (event) => {
    if (event === 'Publish') {

      let configlist = null;
      if (appcomponent.selectedConfigurationForBulkCopy.length === 0) {
        configlist = appcomponent.selectedConfiguration
        console.log("All", configlist)
      }
      else {
        configlist = appcomponent.selectedConfigurationForBulkCopy
        console.log("Selected", configlist)
      }

      //API Bulkpublish
      let url = "bulkPublishConfiguration"
      let postdata = { token: reduxAuth.token, userId: reduxAuth.userId, environmentId: appcomponent.selectedEnvironment.tenantId, configList: configlist }
      console.log(postdata);
      axios.post(url, postdata)
        .then(response => {
          dispatch(actions.configuration());
          dispatch(actions.selectedConfigurationForBulkCopy([]))
          history.push("/Config")
        })
        .catch(err => {
          console.log(err);
          if (typeof err.response != "object") {
            console.log(err);
          }
          else {
            if (err.response.status === 403) {
              dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
            }
          }
        });
      handleDialogClose();
      dispatch(actions.configuration());
      history.push("/Config")

    }
    else {
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
  }

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  //End stepper

  //Select Target Environment
  var autoSelectChangeHandler = (event, value) => {
    if (event.currentTarget.id.includes("select-environment")) {
      // setUserEnvironments(value);
      // console.log(value);
    }
  }

  var handleOnSyncClick = () => {
    setOpenSyncAlert(true);
    setDisabled(true);
    handleActionClose();
  }

  var handleNoAction = () => {
    setOpenSyncAlert(false);
    setDisabled(false);
  }

  var handleYesAction = () => {
    let url = "syncConfigurations"
    const httsAgent = new https.Agent({ rejectUnauthorized: false });
    setOpenSyncProcessAlert(true);
    let postdata = { _id: appcomponent.selectedEnvironment.tenantId, isSync: "0", token: reduxAuth.token, userId: reduxAuth.userId }
    // console.log(postdata);
    axios.post(url, postdata, { httpsAgent: httsAgent })
      .then(response => {
        setOpenSyncAlert(false);
        dispatch(actions.selectedEnvironment({ ...appcomponent.selectedEnvironment, isSync: 0 }));
      })
      .catch(err => {
        console.log(err);
        if (err.response.status === 403) {
          dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
        }
      });
    setOpenSyncAlert(false);
  }

  // let steps=null;
  const handleActionItemClick = (event) => {
    if (event === 'bulkcopy') {
      setSteps(getBulkCopySteps())
      setselectedMenuItem("bulkcopy")
    }
    if (event === 'bulkpublish') {
      setSteps(getBulkPublishSteps())
      setselectedMenuItem("bulkpublish")
    }
    handleActionClose();
    handleDialogClickOpen();
  }

  const authLogoutClick = () => {
    dispatch(actions.authLogout());
    authProvider.logout();
  }

  useEffect(() => {
    let url = "getByIds"
    let postdata = { objectName: "environment", token: reduxAuth.token, userId: reduxAuth.userId, ids: [reduxAuth.defaultEnvironment] }
    axios.post(url, postdata)
      .then(environmentResponse => {

        dispatch(actions.selectedEnvironment(environmentResponse.data.response[0]))
        environmentResponse.data.response.map((data, index) => {
          reduxAuth.defaultEnvironment = data.tenantId
        });
        setState({ environments: environmentResponse.data.response, showLoader: false });
      }).catch(err => {
        if (typeof err.response != "object") {
          console.log(err);
        }
        else {
          if (err.response.status === 403) {
            // console.log(err.response.data.responseMessage);
            dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
          }
        }
      });
  }, []);

  const handleMenuItem = (data, index) => {
    setSelectedIndex(index);
    dispatch(actions.selectedEnvironment(data))
    dispatch(actions.selectedApp(null))
    handleToggle();
  };

  return (
    <div className={classes.grow}>
      {openSyncAlert ?
        <Snackbar open={openSyncAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert severity="warning"
            action={
              <div>
                <Button color="inherit" size="small" onClick={() => handleNoAction()}>
                  No
                </Button>
                <Button color="inherit" size="small" onClick={() => handleYesAction()}>
                  Yes
                </Button>
              </div>}>
            <AlertTitle>Sync Environment</AlertTitle>
              Sync Configurations will Remove all the unpublished configurations stored in the UIConfigurator. Are you sure you wish to proceed?
          </Alert>
        </Snackbar> : null}
      <AppBar position="static" color='transparent'>
        <Toolbar>
          <a href="https://pact.riversand.com"><img src={RSLogo} alt="Riversand" height="30"></img></a> &nbsp;
        {/* <img src={Logo} alt="Dataio" height="30"></img> */}
          {/* //Menu */}
          <div className={classes.search}>
            {state.showLoader ? <CircularProgress size={25} className={classes.loader}></CircularProgress> : null}
            <Button
              id="menu"
              title="Select Environment"
              ref={anchorRef}
              aria-describedby={'menu-list-grow'}
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              style={{ 'borderRadius': '50px' }} variant="contained" color="primary"
              endIcon={<KeyboardArrowDownIcon />}
            // classes={{
            //   root: classes.inputRoot
            // }}
            >
              {appcomponent.selectedEnvironment != null ? appcomponent.selectedEnvironment.displayName : "Environment"}
            </Button>
            <Popover
              id="popover"
              open={open}
              anchorEl={anchorRef.current}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }} >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  {state.environments.map((data, index) => {
                    return (
                      <MenuItem key={index} onClick={() => handleMenuItem(data, index)} className={classes.listitem}>
                        <ListItemIcon className={classes.listitemicon}>
                          {selectedIndex === index ? <CheckCircleIcon style={{ color: green[900] }}></CheckCircleIcon> : <AddCircleIcon></AddCircleIcon>}
                        </ListItemIcon>
                        {data.displayName}
                      </MenuItem>
                    )
                  })
                  }
                </MenuList>
              </ClickAwayListener>
            </Popover>
          </div>
          {/* //End Menu */}
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>

            {/* Action Menu */}
            <Button aria-describedby={id} title="Select Action" endIcon={<KeyboardArrowDownIcon />} style={{ 'borderRadius': '50px' }} variant="contained" color="primary" onClick={handleActionClick}>
              Actions
            </Button>
            <Popover
              id={id}
              open={openAcion}
              anchorEl={anchorEl}
              onClose={handleActionClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}>
              <MenuList>
                <MenuItem onClick={() => handleOnSyncClick()} className={classes.listitem}><ListItemIcon className={classes.listitemicon}><SyncIcon style={{ color: 'red', fontWeight: '100px' }}></SyncIcon></ListItemIcon>Sync Environment</MenuItem>
                {/* <MenuItem onClick={() => handleActionItemClick("bulkcopy")} className={classes.listitem}><ListItemIcon className={classes.listitemicon}><FileCopyIcon></FileCopyIcon></ListItemIcon>Bulk Copy</MenuItem> */}
                <MenuItem disabled={reduxAuth.defaultEnvironment.includes("ds") || reduxAuth.defaultEnvironment.includes("partner") || reduxAuth.defaultEnvironment.includes("presales") || reduxAuth.defaultEnvironment.includes("ascend") || reduxAuth.defaultEnvironment.includes("sepik01") || reduxAuth.defaultEnvironment.includes("px360 ") || reduxAuth.defaultEnvironment.includes("cx360") ? false : true} onClick={() => handleActionItemClick("bulkpublish")} className={classes.listitem}><ListItemIcon className={classes.listitemicon}><PublishIcon></PublishIcon></ListItemIcon>Bulk Publish</MenuItem>
              </MenuList>
            </Popover>
            {/* End Action Menu      */}
            &nbsp;
            <img src={avtar} className="rounded-circle avtar"></img>
            &nbsp;

          <Button style={{ 'borderRadius': '50px' }} variant="contained" color="primary" onClick={() => authLogoutClick()}>Logout</Button>
          </div>
        </Toolbar>
      </AppBar>
      {appcomponent.selectedEnvironment != null && appcomponent.selectedEnvironment.isSync.toString() === "0" ? <Alert severity="warning" style={{ position: 'absolute', top: 10, right: 300 }}>Configuration Sync is in Progress,Please refresh after some time!!</Alert> : null}

      {/* //Dialog */}
      <div>
        <Dialog onClose={handleDialogClose} aria-labelledby="customized-dialog-title" open={openDialog}>
          <DialogTitle id="customized-dialog-title" onClose={handleDialogClose}>

            <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
              {steps.map(label => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <div className={classes.div}>
              {activeStep != 0 ?
                <Button title="Back" variant='outlined' color="primary" onClick={handleBack} className={classes.button} style={{ fontSize: '0.700rem', fontWeight: 600 }}>
                  Back
                </Button> : null
              }
              <Button
                variant="contained"
                color={activeStep === steps.length - 1 ? '' : 'primary'}
                style={{ fontSize: '0.700rem', fontWeight: 600, backgroundColor: 'green', color: 'white' }}
                onClick={(event) => handleNext(activeStep === steps.length - 1 ? 'Publish' : 'Next')}
                className={classes.button}>
                {activeStep === steps.length - 1 ? 'Publish' : 'Next'}
              </Button>
              {/* {activeStep === 0 ?
                <Button variant='outlined' color="primary" onClick={handleCancle} className={classes.button} style={{ fontSize: '0.700rem', fontWeight: 600 }}>
                  Cancel
                </Button> : null
              } */}
            </div>
          </DialogTitle>
          <DialogContent dividers>
            {activeStep === 0 && (appcomponent.selectedConfigurationForBulkCopy.length > 0) ?
              <MaterialTable
                columns={columns}
                data={appcomponent.selectedConfigurationForBulkCopy.length > 0 ? appcomponent.selectedConfigurationForBulkCopy : []}
                options={{
                  search: false,
                  toolbar: false
                }} /> : null}
            {activeStep === 0 && (appcomponent.selectedConfigurationForBulkCopy.length <= 0) ?
              <div>
                <WarningIcon style={{ fontSize: '150px', color: '#ffa726', marginLeft: '150px' }}></WarningIcon>
                <Alert severity="warning">{selectedMenuItem === 'bulkcopy' ? "You are goining to copy all Config" : "You are goining to publish all Configurations"}</Alert>
              </div>
              : null}
            {activeStep != 0 && selectedMenuItem === 'bulkcopy' ?
              <div style={{ marginLeft: '90px', height: '100px' }}>
                <Autocomplete
                  id="select-environment"
                  name="environment"
                  options={state.environments}
                  onChange={autoSelectChangeHandler}
                  getOptionLabel={option => option.displayName}
                  style={{ width: 250 }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Environments"
                      placeholder="Environments"
                      fullWidth />
                  )} />
              </div> : null}
            {activeStep != 0 && selectedMenuItem === 'bulkpublish' ?
              <div>
                <WarningIcon style={{ fontSize: '150px', color: '#ffa726', marginLeft: '150px' }}></WarningIcon>
                <Alert severity="warning">Are You Sure??</Alert>
              </div> : null}
            <Divider></Divider>
          </DialogContent>
        </Dialog>
      </div>
      {/* //End Dialog */}
    </div>
  );
}


